<template>
  <div>
    <div class="navigation">
      <div class="navigation_bottom">
        <img class="ai_assistant" ref="ai_assistant"
          src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/AI_Ass/AI_Ass.png" alt="">
        <span ref="scroll_bottom" class="scroll_bottom iconfont" @click="scrollToBottom">&#xe685; 回到底部</span>
      </div>
      <div class="navigation_items" ref="navigation_items">
        <div class="main_input" ref="main_input">
          <!-- 已上传图片缩略图区域 -->
          <div v-if="uploadImages.length > 0" class="uploaded-thumbnails">
            <div v-for="(img, idx) in uploadImages" :key="idx" class="thumbnail-item">
              <img :src="img" alt="上传图片" class="thumbnail-img">
              <div class="remove-btn" @click.stop="removeImage(idx)">×</div>
            </div>
          </div>
          <!-- 输入框区域 -->
          <div class="input-area">
            <textarea name="" id="" placeholder="描述你想要的产品拼接效果（可选）..."
              v-model="textarea"
              @focus="handleTextareaFocus"
              @input="handleTextareaInput"
              @blur="handleTextareaBlur"
              @click="handleTextareaClick"
              :disabled="processing"></textarea>
            <button ref="up" class="sent iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="!scrollStatus" :disabled="!canSend || processing">
              <span v-if="!processing">&#xe688;</span>
              <span v-else class="rotating">&#xe6a4;</span>
            </button>
          </div>
          <!-- 底部功能按钮行 - 在输入框下方 -->
          <div class="input-options" @click.stop>
            <!-- 上传按钮 -->
            <div class="option-btn" @click.stop="handleImageUpload">
              <span>+上传</span>
            </div>
            <!-- 图像大小按钮 -->
            <div class="option-btn image-size-btn">
              <span>图像大小：2K</span>
            </div>
          </div>
        </div>
        <!-- 放大后的发送按钮（绝对定位） -->
        <button ref="down" class="sent_expanded iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="scrollStatus" :disabled="!canSend || processing">
          <span v-if="!processing">&#xe688;</span>
          <span v-else class="rotating">&#xe6a4;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { getOssClient } from '@/utils/oss'
import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { getLastUsedBaseUrl, getWebSocketUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import productSplicingWorkflow from '@/api/json_api/产品拼接.json'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { PRODUCT_SPLICING } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
export default {
  name: 'NaviGation_ProductSplicing',
  props: {
    initialChatHistory: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      textarea: '',
      uploadImages: [], // 上传的图片URL数组（最多10张）
      processing: false,
      splicingChatHistory: [],
      scrollStatus: false,
      // WebSocket
      ws: null,
      clientId: '',
      // 防止重复获取图片标志
      imageFetched: false,
      // 任务日志ID
      taskLogId: null,
      // OSS 配置
      ossConfig: {
        accessKeyId: OSS_ACCESS_KEY_ID,
        accessKeySecret: OSS_ACCESS_KEY_SECRET
      },
      // 节点名称映射
      nodeNameMap: {
        1: 'Image scaling',
        2: 'CFG normalize',
        3: 'Model sampling',
        4: 'Load CLIP',
        5: 'Load VAE',
        6: 'VAE encode',
        7: 'Text encode',
        8: 'Conditioning zero out',
        10: 'KSampler',
        11: 'VAE decode',
        14: 'Load UNet',
        16: 'Load LoRA (lightning)',
        17: 'Load LoRA (pingkou)',
        23: 'Clean GPU',
        24: 'Upload to OSS',
        25: 'Load input image'
      },
      currentExecutingNode: '',
      // 默认基础提示词
      basePrompt: 'PPPKKK, Using the color and texture of the nail tip in the picture, generate a glass bottle mouth with threads that has the same color and texture.',
      // 批量处理相关
      batchQueue: [],
      batchResults: [],
      batchTotal: 0,
      batchCompleted: 0,
      isBatchProcessing: false
    }
  },
  computed: {
    canSend() {
      return this.uploadImages.length > 0
    }
  },
  created() {
    if (this.initialChatHistory && this.initialChatHistory.length > 0) {
      this.splicingChatHistory = [...this.initialChatHistory]
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyPaste)
    document.addEventListener('click', this.closeAllMenus)
    this.$root.$on('productsplicing-regenerate', this.handleRegenerateFromParent)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPaste)
    document.removeEventListener('click', this.closeAllMenus)
    this.$root.$off('productsplicing-regenerate', this.handleRegenerateFromParent)
  },
  methods: {
    // 处理图片上传（支持多选，最多10张）
    handleImageUpload() {
      if (this.processing) return
      const remaining = 10 - this.uploadImages.length
      if (remaining <= 0) {
        Message.warning('最多只能上传10张图片!')
        return
      }
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.multiple = true
      input.onchange = async (event) => {
        const files = Array.from(event.target.files)
        if (files.length === 0) return
        const toUpload = files.slice(0, remaining)
        if (files.length > remaining) {
          Message.warning(`最多还能上传${remaining}张图片，已自动截取前${remaining}张`)
        }
        for (const file of toUpload) {
          await this.processImage(file)
        }
      }
      input.click()
    },

    // 处理图片文件
    async processImage(file) {
      try {
        Message.info('正在上传图片...')
        const ossClient = await getOssClient()
        const tmp = '/input/'
        const fileName = `productsplicing_${Date.now()}_${file.name}`
        const result = await ossClient.put(tmp + fileName, file)

        console.log('OSS上传结果:', result)

        if (result.name) {
          const imageUrl = `https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/${result.name}`
          console.log('生成的图片URL:', imageUrl)
          this.uploadImages.push(imageUrl)
          Message.success('图片上传成功!')
        } else {
          Message.error('图片上传失败，请重试!')
        }
      } catch (error) {
        console.error('上传图片失败:', error)
        Message.error('图片上传失败，请检查网络!')
      }
    },

    // 移除图片（按索引）
    removeImage(index) {
      this.uploadImages.splice(index, 1)
    },

    // 关闭所有下拉菜单
    closeAllMenus() {
      // 当前没有下拉菜单需要关闭
    },

    // 处理 textarea 获得焦点
    handleTextareaFocus() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 输入
    handleTextareaInput() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 失去焦点
    handleTextareaBlur() {
      // 不做任何处理，保持当前状态
    },
    // 处理 textarea 点击
    handleTextareaClick() {
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 导航栏状态
    handleScroll(val) {
      if (val) {
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '70%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 1
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 1
        this.scrollStatus = true
      } else {
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '60%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 0
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 0
        this.scrollStatus = false
      }
    },
    // 回滚到底部
    scrollToBottom() {
      if (this.scrollStatus) {
        this.$emit('scrollToBottom')
      }
    },

    // Ctrl+V 粘贴图片
    async handleKeyPaste(event) {
      if (event.ctrlKey && event.key === 'v') {
        try {
          const items = (event.clipboardData || window.clipboardData).items
          for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
              const blob = items[i].getAsFile()
              await this.processImage(blob)
              break
            }
          }
        } catch (error) {
          console.error('粘贴图片失败:', error)
        }
      }
    },

    // 处理来自父组件的重新生成请求
    handleRegenerateFromParent(regenerateData) {
      if (!regenerateData) return
      console.log('接收到重新生成请求:', regenerateData)
      this.textarea = regenerateData.content
      this.uploadImages = regenerateData.images || []
      sessionStorage.removeItem('productsplicing_regenerate')
      this.$nextTick(() => {
        this.startTask()
      })
    },

    // 合并用户输入和基础提示词
    mergePrompt(userInput) {
      if (!userInput || userInput.trim() === '') {
        return this.basePrompt
      }
      return `${this.basePrompt}, ${userInput.trim()}`
    },

    // 替换工作流中的动态变量
    replaceWorkflowVariables(workflow, seed, imageUrl, prompt, filename) {
      const workflowCopy = JSON.parse(JSON.stringify(workflow))
      console.log('🔍 开始替换工作流变量...')
      console.log('参数:', { seed, imageUrl, prompt })

      // 遍历所有节点替换变量
      for (const nodeId in workflowCopy) {
        const node = workflowCopy[nodeId]
        if (node.inputs) {
          for (const inputKey in node.inputs) {
            const inputValue = node.inputs[inputKey]
            if (typeof inputValue === 'string') {
              if (inputValue.includes('{{SEED}}')) {
                node.inputs[inputKey] = String(seed)
                console.log(`✅ 节点${nodeId}.${inputKey}: {{SEED}} -> ${seed}`)
              } else if (inputValue.includes('{{INPUT_IMAGE_URL}}')) {
                node.inputs[inputKey] = imageUrl
                console.log(`✅ 节点${nodeId}.${inputKey}: {{INPUT_IMAGE_URL}} -> ${imageUrl}`)
              } else if (inputValue.includes('{{OUTPUT_FILENAME}}')) {
                node.inputs[inputKey] = filename
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OUTPUT_FILENAME}} -> ${filename}`)
              } else if (inputValue.includes('{{OSS_ACCESS_KEY_ID}}')) {
                node.inputs[inputKey] = this.ossConfig.accessKeyId
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OSS_ACCESS_KEY_ID}} -> ${this.ossConfig.accessKeyId}`)
              } else if (inputValue.includes('{{OSS_ACCESS_KEY_SECRET}}')) {
                node.inputs[inputKey] = this.ossConfig.accessKeySecret
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OSS_ACCESS_KEY_SECRET}} -> [已隐藏]`)
              } else if (inputValue.includes('{{PROMPT}}')) {
                node.inputs[inputKey] = prompt
                console.log(`✅ 节点${nodeId}.${inputKey}: {{PROMPT}} -> ${prompt}`)
              }
            }
          }
        }
      }

      // seed 节点转回 Number（KSampler 需要数字类型）
      if (workflowCopy['10'] && workflowCopy['10'].inputs && typeof workflowCopy['10'].inputs.seed === 'string') {
        const seedNum = Number(workflowCopy['10'].inputs.seed)
        if (!Number.isNaN(seedNum)) {
          workflowCopy['10'].inputs.seed = seedNum
        }
      }

      console.log('🔍 替换后的工作流:', JSON.stringify(workflowCopy, null, 2))
      return workflowCopy
    },

    // 开始任务（批量顺序处理）
    async startTask() {
      if (!this.canSend || this.processing) {
        return
      }

      if (!this.scrollStatus) {
        this.handleScroll(true)
      }

      if (this.uploadImages.length === 0) {
        Message.warning('请先上传图片!')
        return
      }

      const userMessage = this.textarea.trim()
      const userImages = [...this.uploadImages]
      const mergedPrompt = this.mergePrompt(userMessage)

      // 清空输入
      this.textarea = ''
      this.uploadImages = []

      // 初始化批量处理队列
      this.batchQueue = [...userImages]
      this.batchResults = []
      this.batchTotal = userImages.length
      this.batchCompleted = 0
      this.isBatchProcessing = true

      // 添加用户消息到历史
      this.splicingChatHistory.push({
        role: 'user',
        content: userMessage || `使用默认设置进行产品拼接（共${userImages.length}张）`,
        images: userImages,
        timestamp: new Date().toISOString()
      })

      // 添加AI占位消息
      const imageSlots = userImages.map(() => ({ status: 'loading' }))
      this.splicingChatHistory.push({
        role: 'assistant',
        content: '',
        imageSlots: imageSlots,
        totalImages: userImages.length,
        completedImages: 0,
        timestamp: new Date().toISOString()
      })

      this.$emit('chatUpdate', this.splicingChatHistory)
      this.$emit('aiTyping', true)

      this.processing = true

      this.$nextTick(() => {
        this.handleScroll(true)
      })

      await this.processNextInBatch(mergedPrompt)
    },

    // 处理批量队列中的下一张图片
    async processNextInBatch(mergedPrompt) {
      if (this.batchQueue.length === 0) {
        this.isBatchProcessing = false
        this.processing = false
        this.$emit('aiTyping', false)
        this.$emit('nodeUpdate', '')
        Message.success(`全部${this.batchTotal}张图片产品拼接完成!`)
        return
      }

      const currentImage = this.batchQueue.shift()
      console.log(`🖼️ 正在处理第 ${this.batchCompleted + 1}/${this.batchTotal} 张图片`)

      try {
        const seed = Math.floor(Math.random() * 100000000000000)
        const timestamp = Date.now()
        const randomNum = Math.floor(Math.random() * 99999)
        const filename = `["tmp-comfyui/productsplicing/${timestamp}_${randomNum}.png"]`

        console.log('🎲 生成的种子:', seed)
        console.log('🖼️ 当前图片URL:', currentImage)
        console.log('📝 合并后的提示词:', mergedPrompt)

        const promptData = this.replaceWorkflowVariables(
          productSplicingWorkflow,
          seed,
          currentImage,
          mergedPrompt,
          filename
        )

        this.clientId = uuidv4()
        const data = {
          prompt: promptData,
          client_id: this.clientId
        }

        console.log('🚀 准备发送产品拼接任务...')

        const result = await genPrompt(data)

        if (result && result.prompt_id) {
          console.log('✅ 任务提交成功，promptId:', result.prompt_id)
          await this.listenToBatchProgress(result.prompt_id, mergedPrompt, currentImage)
        } else {
          throw new Error('任务提交失败')
        }
      } catch (error) {
        console.error('❗ 产品拼接失败:', error)
        let errorMessage = '产品拼接失败，请稍后再试!'
        if (error.response) {
          errorMessage = `服务器错误: ${error.response.status}`
        } else if (error.message) {
          errorMessage = error.message
        }
        this.batchCompleted++
        this.batchResults.push({ image: currentImage, error: true })
        this.updateAssistantMessage()
        this.$emit('chatUpdate', this.splicingChatHistory)
        Message.error(errorMessage)
        await this.processNextInBatch(mergedPrompt)
      }
    },

    // 监听批量处理中单张图片的进度
    async listenToBatchProgress(promptId, mergedPrompt, taskImage) {
      this.imageFetched = false
      this.ws = new WebSocket(`${getWebSocketUrl()}/ws?clientId=${this.clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时，尝试继续获取结果...')
        this.ws.close()
        if (!this.imageFetched) {
          this.imageFetched = true
          this.fetchBatchResultImage(promptId, mergedPrompt)
        }
      }, 30000)
      this.ws.onopen = () => {
        console.log('✅ WebSocket 连接成功')
        getTaskStart({
          type: PRODUCT_SPLICING,
          prompt: mergedPrompt || '',
          input_images: taskImage ? [taskImage] : []
        }).then(rep => {
          this.taskLogId = rep.data.task.id
          this.$emit('taskLogId', this.taskLogId)
        })
        clearTimeout(wsTimeout)
      }
      this.ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(data)
            if (msg.type !== 'crystools.monitor') {
              console.log('📡 收到消息:', msg)
            }

            if (msg.type === 'executing') {
              const execData = msg.data
              if (execData.node === null && execData.prompt_id === promptId) {
                console.log(`✅ 第 ${this.batchCompleted + 1}/${this.batchTotal} 张产品拼接完成`)
                this.currentExecutingNode = ''
                this.$emit('nodeUpdate', '')
                this.ws.close()
                if (!this.imageFetched) {
                  this.imageFetched = true
                  await this.fetchBatchResultImage(promptId, mergedPrompt)
                }
              } else if (execData.node !== null) {
                const nodeName = this.nodeNameMap[execData.node] || `Executing node ${execData.node}`
                this.currentExecutingNode = `${nodeName} (${this.batchCompleted + 1}/${this.batchTotal})`
                this.$emit('nodeUpdate', this.currentExecutingNode)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              this.$emit('progressUpdate', current)
            } else if (msg.type === 'execution_error') {
              console.error('❌ 执行错误:', msg.data)
              this.batchCompleted++
              this.batchResults.push({ image: '', error: true })
              this.updateAssistantMessage()
              this.$emit('chatUpdate', this.splicingChatHistory)
              Message.error(`第 ${this.batchCompleted} 张图片产品拼接失败`)
              this.ws.close()
              await this.processNextInBatch(mergedPrompt)
            }
          } catch (error) {
            console.error('WebSocket消息解析失败:', error)
          }
        }
      }
      this.ws.onclose = async () => {
        console.log('🔌 WebSocket 连接关闭')
        try {
          const index = await cudaIndexNum()
          if (index) {
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          }
        } catch (error) {
          console.log(error)
        }
      }
      this.ws.onerror = (error) => {
        console.error('❌ WebSocket 错误:', error)
        setTimeout(async () => {
          if (!this.imageFetched) {
            console.log('🔄 WS错误后尝试检查任务结果...')
            this.imageFetched = true
            await this.fetchBatchResultImage(promptId, mergedPrompt)
          }
        }, 3000)
      }
    },

    // 获取批量处理中单张结果图片
    async fetchBatchResultImage(promptId, mergedPrompt) {
      try {
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: { 'Content-Type': 'application/json' }
        })
        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        if (promptInfo.status.status_str === 'success') {
          const promptIndex = 2
          const nodeId = '24'
          console.log('📄 历史记录结构:', JSON.stringify(promptInfo.prompt, null, 2))
          if (!promptInfo.prompt || !promptInfo.prompt[promptIndex] || !promptInfo.prompt[promptIndex][nodeId]) {
            console.error(`历史记录结构异常，无法找到节点${nodeId}的数据`)
            this.batchCompleted++
            this.batchResults.push({ image: '', error: true })
            this.updateAssistantMessage()
            this.$emit('chatUpdate', this.splicingChatHistory)
            await this.processNextInBatch(mergedPrompt)
            return
          }
          const filenameStr = promptInfo.prompt[promptIndex][nodeId].inputs.filename
          const tmp = JSON.parse(filenameStr)
          const imageUrl = genOssImage(tmp[0])
          console.log(`✅ 第 ${this.batchCompleted + 1} 张图片URL:`, imageUrl)

          this.batchCompleted++
          this.batchResults.push({ image: imageUrl, error: false })

          this.updateAssistantMessage()
          this.$emit('chatUpdate', this.splicingChatHistory)

          await this.recordTaskEnd(imageUrl)
          await this.processNextInBatch(mergedPrompt)
        } else {
          this.batchCompleted++
          this.batchResults.push({ image: '', error: true })
          this.updateAssistantMessage()
          this.$emit('chatUpdate', this.splicingChatHistory)
          Message.error(`第 ${this.batchCompleted} 张图片产品拼接失败`)
          await this.processNextInBatch(mergedPrompt)
        }
      } catch (error) {
        console.error('获取图片失败：', error)
        this.batchCompleted++
        this.batchResults.push({ image: '', error: true })
        this.updateAssistantMessage()
        this.$emit('chatUpdate', this.splicingChatHistory)
        Message.error('获取生成结果失败')
        await this.processNextInBatch(mergedPrompt)
      }
    },

    // 更新AI占位消息
    updateAssistantMessage() {
      let lastAiIndex = -1
      for (let i = this.splicingChatHistory.length - 1; i >= 0; i--) {
        if (this.splicingChatHistory[i].role === 'assistant') {
          lastAiIndex = i
          break
        }
      }
      if (lastAiIndex === -1) return

      const aiMessage = this.splicingChatHistory[lastAiIndex]

      if (!aiMessage.imageSlots) {
        aiMessage.imageSlots = []
        for (let i = 0; i < this.batchTotal; i++) {
          aiMessage.imageSlots.push({ status: 'loading' })
        }
      }

      for (let i = 0; i < this.batchResults.length; i++) {
        const result = this.batchResults[i]
        if (result.error) {
          aiMessage.imageSlots[i] = { status: 'error' }
        } else {
          aiMessage.imageSlots[i] = { status: 'done', image: result.image }
        }
      }

      aiMessage.completedImages = this.batchCompleted

      if (this.batchCompleted >= this.batchTotal) {
        const successCount = this.batchResults.filter(r => !r.error).length
        aiMessage.content = successCount > 0
          ? `产品拼接完成！成功 ${successCount}/${this.batchTotal} 张`
          : '抱歉，所有图片拼接均失败'
        aiMessage.isError = successCount === 0
      }
      this.$set(this.splicingChatHistory, lastAiIndex, { ...aiMessage })
    },

    // 记录任务结束
    async recordTaskEnd(imageUrl) {
      try {
        const imgInfo = await getImageSizeByLoading(imageUrl)
        const info = {
          details: [{ path: imageUrl, imgInfo: imgInfo }]
        }
        await getTaskEnd({ result: JSON.stringify(info) }, this.taskLogId)
      } catch (error) {
        console.error('记录任务结束失败:', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.active {
  background: @basicselect;
}

.navigation {
  position: absolute;
  width: calc(100vw - 80px);
  bottom: 15px;
  left: 100px;
  z-index: 8;
  transition: all 0.5s;

  .navigation_bottom {
    position: relative;
    width: 1536px;
    height: 50px;
    font-size: 23px;
    margin: 0 auto;
    justify-content: space-between;
    margin-bottom: 10px;

    .ai_assistant {
      position: absolute;
      bottom: -10px;
      width: 120px;
      height: 120px;
      opacity: 0;
      transition: all 0.5s;
    }

    .scroll_bottom {
      position: absolute;
      right: 0px;
      font-size: 20px;
      color: @font_white;
      background-color: #c1c1c1;
      padding: 10px 15px;
      cursor: pointer;
      border-radius: @border_radius_3;
      transition: all 0.5s;
      opacity: 0;
    }
  }

  .navigation_items {
    position: relative;
    width: 1336px;
    height: 220px;
    display: flex;
    flex-direction: column;
    background: rgba(235, 235, 235, 0.5);
    backdrop-filter: blur(10px);
    border: 1px solid @font_white;
    border-radius: @border_radius;
    transition: all 0.3s;
    margin: 0 auto;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);

    .main_input {
      width: 100%;
      height: 220px;
      display: flex;
      flex-direction: column;
      padding: 15px 20px;
      gap: 10px;

      // 已上传图片缩略图区域
      .uploaded-thumbnails {
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
        overflow-x: auto;
        padding: 4px 0;
        flex-shrink: 0;
        height: 68px;

        &::-webkit-scrollbar {
          height: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d0d0d0;
          border-radius: 2px;
        }

        .thumbnail-item {
          position: relative;
          width: 60px;
          height: 60px;
          border-radius: 8px;
          overflow: hidden;
          flex-shrink: 0;
          border: 2px solid #e5e7eb;
          transition: all 0.3s;

          &:hover {
            border-color: @morejoy;
            transform: scale(1.05);
          }

          .thumbnail-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .remove-btn {
            position: absolute;
            top: 2px;
            right: 2px;
            width: 16px;
            height: 16px;
            background: rgba(0, 0, 0, 0.6);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            cursor: pointer;
            transition: all 0.3s;
            line-height: 1;

            &:hover {
              background: rgba(255, 0, 0, 0.8);
              transform: scale(1.1);
            }
          }
        }
      }

      // 输入框区域
      .input-area {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 15px;
        position: relative;
        min-height: 60px;

        textarea {
          flex: 1;
          height: 100%;
          min-height: 60px;
          font-family: '微软雅黑';
          font-size: 23px;
          padding: 10px 20px;
          border: none;
          background: none;
          resize: none;
          outline: none;
        }

        .sent {
          position: absolute;
          right: 0;
          width: 60px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          font-size: 35px;
          color: @font_white;
          border: none;
          border-radius: 30px;
          background-color: @font_gray;
          cursor: pointer;
          opacity: 0.7;
          transition: all 0.3s;

          &.has_input {
            background-color: @morejoy;
            opacity: 1;
          }

          &:hover:not(:disabled) {
            opacity: 1;
            font-size: 38px;
          }

          &:disabled {
            opacity: 0.3;
            cursor: not-allowed;
          }

          .rotating {
            animation: rotate 1s linear infinite;
          }
        }
      }

      // 底部按钮区域
      .input-options {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        height: 40px;

        .option-btn {
          position: relative;
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 12px;
          background: white;
          border: 1px solid #d0d0d0;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          user-select: none;
          font-size: 13px;
          color: #333;
          font-weight: 500;

          &:hover {
            border-color: @morejoy;
            background: #fff8f3;
          }
        }
      }
    }

    /* 放大后的发送按钮（绝对定位） */
    .sent_expanded {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      font-size: 35px;
      color: @font_white;
      border: none;
      border-radius: 30px;
      background-color: @font_gray;
      cursor: pointer;
      opacity: 0.7;
      transition: all 0.3s;
      z-index: 10;

      &.has_input {
        background-color: @morejoy;
        opacity: 1;
      }

      &:hover:not(:disabled) {
        opacity: 1;
        font-size: 38px;
      }

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }

      .rotating {
        animation: rotate 1s linear infinite;
      }
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
